import React from "react";
import { useTranslation } from "react-i18next";

import Callout from "components/callout/Callout";
import Spin from "components/spin/spin";
import { ICreditCard } from "pages/guest/Customer/CustomerProfile";
import CreditCardTab from "./CreditCardTab";
import { ButtonNew as Button } from "components/buttonNew";

type CreditCardCatalogueProps = {
  customerId: number; //necessary for spinner to appear on async calls

  creditCards: ICreditCard[];
  selectedCard: number;
  setSelectedCard: (paymentId: number) => void;
  backButtonAction?: () => void;

  /** Hide 'Select Credit Card' from the component */
  hideTitle?: boolean;
};

export default function CreditCardCatalogue(props: CreditCardCatalogueProps) {
  const { customerId, creditCards, selectedCard, hideTitle, backButtonAction } = props;
  const { t } = useTranslation();

  const noCustomerSelected = customerId === null || customerId === undefined;
  const creditCardsLoading =
    (customerId !== null || customerId !== undefined) && (creditCards === undefined || creditCards === null);

  return (
    <div className="flex flex-column">
      {!hideTitle && (
        <p className="text-lg text-semibold my-2">{t("Select Credit Card")}</p>
      )}
      {noCustomerSelected ? (
        <Callout
          type="info"
          title={t("Select a customer")}
          content={t("A customer must be selected to load available payment methods")}
        />
      ) : (
        <>
          {creditCardsLoading ? (
            <div style={{ display: "flex", width: "2rem", height: "4.5rem", margin: "auto" }}>
              <Spin className="self-center" />
            </div>
          ) : (
            <>
              {creditCards.length >= 1 ? (
                <div className="ui-checkbox-group">
                  {creditCards.map((paymentMethod, index) => {
                    return (
                      <CreditCardTab
                        key={index}
                        card={paymentMethod}
                        isSelected={paymentMethod.id === selectedCard}
                        setSelectedCard={props.setSelectedCard}
                      />
                    );
                  })}
                </div>
              ) : (
                <Callout
                  type="warning"
                  title={t("Add a payment method")}
                  content={t("Customer does not have any saved payment methods on their account")}
                />
              )}
              {backButtonAction && (
                <Button size="medium" type="text" onClick={backButtonAction}>
                  {t("Back")}
                </Button>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
